// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.library {
    margin-top: 25px;
}


.tab-box-video {
    width: 100%;

}

.tab-box-video ul {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.tab-box-video ul li {
    list-style: none;
    /* font-weight: 500; */
    font-size: 18px;
    padding: 5px 0;
    margin: 0px 25px;
    color: #878395;
    cursor: pointer;
}

.tab-box-video ul li svg {
    fill: #878395;
}

.tab-box-video ul li.active {
    border-top: 3px solid #6c2fbb;
    color: #6c2fbb;
}

.tab-box-video ul li.active svg {
    fill: rgba(108, 47, 187, 1);
}

.like-cmt-select > select {
    height: 50px;
    font-size: 15px;
}

.like-cmt-select > span {
    position: absolute;
    font-size: 13px;
    left: 30px;
    top: 2px;
    color: #878787;
}

.like-cmt-select button span {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #555;
    display: inline-block;
}

.like-cmt-select button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
    top: 25px;
    width: 50px;
    background-color: #f5f7f6;
}

.like-cmt-select button.sort-videos {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    /* left: 117px; */
    top: 25px;
    padding: 0;
    width: 26px;
    background-color: #f5f7f6;
}

.poster {
    width: 100%;
    height: 160px;
}

.custom-card {
    /* background-color: #fff; */
    width: 100%;
    height: auto;
    padding: 6px;
    /* box-shadow: 0px 0px 10px 0px #dad8d8; */
}

.custom-card .v-title-edit {
    display: flex;
}

.custom-card .v-title-edit .v-title-btn {
    cursor: pointer;
    margin: 0;
    display: none;
    padding-left: 5px;
}

.custom-card .v-title-edit:hover .v-title-btn {
    display: inline-block;
}
.v-title-edit:hover .v-title-btn {
    display: inline-block;
}

.custom-card .v-title {
    padding: 2px;
    cursor: text;
    font-weight: 500;
    font-size: 14px;
    color: #000;
}

.custom-card p {

    /*font-size: 16px;
    font-weight:400 !important;*/
    font-size: 12px;
    font-weight: 400;
    width: inherit;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-top: 0;
    margin-bottom: 0;
    color: rgba(136, 133, 142, 1);
}

.move-check {
    width: 20px;
    height: 20px;
    border-color: #bdbdbd;
    box-shadow: none;
}
.move-check:checked {
    background-color: #6c2fbb;
    border-color: #6c2fbb;
}


.btn-delete {
    background-color: #6c2fbb;
    color: #FFF;
    border-radius: 4px;
}

.btn-login {
    color: #6c2fbb;
    border: 1px solid #6c2fbb;
    border-radius: 4px;
}

.FF-scroll-modify {
    /*max-height: 720px;*/
    /*height: 100%;*/
    height: 66vh;
    overflow-x: hidden;
    overflow-y: scroll;
    margin-top: 20px;
}

/*.vid-options select {*/
/*    border-radius: 10px;*/
/*    border: none !important;*/
/*    height: 50px;*/

/*}*/

.vid-options {
    width: 100%;
}

.vid-options > select {
    height: 50px;
    font-size: 15px;
}
.vid-options > label {
    position: absolute;
    font-size: 15px;
    left: 30px;
    top: 15px;
    color: #878787;
}

.group-box {
    padding: 30px;
    border-radius: 16px;
    background-color: #ffff;
}

.dots {
    background-color: #000000a2;
    display: flex;
    align-items: center;
    -moz-column-gap: 5px;
         column-gap: 5px;
    border-radius: 0 5px;
}

.dots-dropdown {
    position: absolute;
    top: 12px;
    right: 12px;
    background-color: #929292a2;
    display: flex;
    cursor: pointer;
    align-items: center;
    -moz-column-gap: 10px;
    column-gap: 10px;
    padding: 7px 12px;
    border-radius: 5px;
}
.dots-dropdown .dropdown-menu {
    padding-block: 4px;
    min-width: 120px;
}
.dots-dropdown .dropdown-item {
    padding: 7px 15px;
}
.dots-dropdown .dropdown-item:active,
.dots-dropdown .dropdown-item:hover {
    background-color: #f2f2f2;
}

.bulk-group {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    gap: 10px;
}

.dots-btn {
    cursor: pointer;
    padding: 7px 10px;
}

.badge-box-container {
    text-align: center;
    cursor: pointer;
}

.img-box {
    /*cursor: pointer;*/
    aspect-ratio: 16/9;
    display: flex;
    justify-content: center;
    /*height: 200px;*/
    width: 100%;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    background: #f8f9fa;
    align-items: center;

    /* cursor: pointer;
    height: 200px; */
}

.group-box .add-box {
    aspect-ratio: 16/9;
    position: relative;
    width: 100%;
    /* min-height: 200px; */
    height: 100%;
    border: 2px solid #6c2fbb;;
    border-radius: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
}

.group-box .add-box .plus {
    width: 28px;
    height: 26px;
    background: #F8FAFB;
    border-radius: 4px;
    text-align: center;
}

.group-box .add-box h5 {
    color: #6c2fbb;
}

.img-box img {
    object-fit: fill;
}

.showPdf img {
    width: 190px;
    height: 175px;
    /*min-width: 168px; */
}
.showPdf input{
    text-align: center;
    padding: 2px 0 2px 5px;
    cursor: text;
    font-weight: 500;
    font-size: 15px;
    color: #000;
}
.docBox{
    max-height: 220px;
}

.folderSort{
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.information-modal p{
    color: gray;
    font-size: 18px;
}

.information-modal button{
    color: white;
    padding: 10px 26px;
    font-size: 18px;
    border: none;
    background: #6c2fbb;
    border-radius: 6px;
}

.pdf-edit{
    display: none;
}

.pdf-title:hover .pdf-edit{
    display: block;
}

.folder-section{
    padding: 6px;
}

.folder-section p{
    padding: 2px;
    cursor: text;
    font-weight: 500;
    font-size: 14px;
    color: #000;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.folder-table{
    height: 66vh;
    overflow-x: hidden;
    overflow-y: scroll;
}

.folder-table table tbody tr{
    line-height: 3;
}

ol li{
    font-size: 18px;
}

.breadcrumb-item.active{
    color: #6c2fbb !important;
    font-weight: bold;
    margin: -2px 0 0 0;
}

.firstLi{
    cursor: pointer;
}

.addFolderButton button{
    font-size: 15px;
    border: 2px solid #6c2fbb;
    display: flex;
    align-items: center;
    gap: 7px;
    color: #6c2fbb;
    font-weight: 500;
    border-radius: 8px;
}
.folderModalBody{
    display: flex;
    flex-direction: column;
    text-align: start;
    margin-top: 30px;
    padding: 0 16px;
}

.folderModalBody input{
    height: 45px;
    font-size: 15px;
    font-weight: 500;
}

.folderModalBody label{
    font-size: 15px;
    font-weight: 500;
}

#modalForAddFolder h4{
    border-bottom: 1px solid #e1e1e1;
    line-height: 2.5;
}

#modalForAddFolder .btnSave, #modalForDisplayVideoList .btnSave, #modalForMoveVideoListToFolder .btnSave, #foldersModal .btnSave{
    font-size: 15px;
    border: 2px solid #6c2fbb;
    display: flex;
    align-items: center;
    gap: 7px;
    color: white;
    font-weight: 500;
    border-radius: 5px;
    background: #6c2fbb
}

.mainsection{
    height: calc(100vh - 120px);
    overflow: auto;
}

#modalForDisplayVideoList img, #modalForMoveVideoListToFolder img{
    height: 70px;
    width: 180px !important;
}

#modalForDisplayVideoList .form-check-input, #modalForMoveVideoListToFolder .form-check-input{
    position: unset !important;
}

.videoImage{
    object-fit: fill;
    height: 100%;
}

.breadcrumb-item+.breadcrumb-item::before {
    display: inline-block;
    padding-right: .5rem;
    color: #6c757d;
    content: ">";
}

.breadcrumb-item+.breadcrumb-item::before {
    display: inline-block;
    padding-right: .5rem;
    color: #6c757d;
    content: "";
    background-image: url('right-arrow.svg');
    background-repeat: no-repeat;
    background-size: contain;
    width: 20px;
    height: 15px;
    margin-top: 8px;
}

.badgeAction {
    text-align: end;
    position: absolute;
    right: 15px;
    top: 0;
}


.badge-box .badge-rounded{
    z-index: 0 !important;
}

.popup-objective {
    z-index: 1;
    position: absolute;
    background: white;
    padding: 0 7px;
    border-radius: 6px;
    width: -moz-fit-content;
    width: fit-content;
    top: 30px;
    width: 200px;
    height: 210px;
    overflow: auto;
    left: -66px
}

.popup-objective ul {
    text-align: start;
    padding-left: 25px;
}

.popup-objective li {
    margin-top: 10px;
}

.verticalLine{
    border-left: 1px solid #9b9b9b;
    height: 16px;
    display: block;
}

.tab-dropdown {
    position: relative;
}
.tab-dropdown:hover .tab-menu {
    transform: scale(1);
}
.tab-dropdown .tab-arrow {
    transition: all 0.2s;
}
.tab-dropdown:hover .tab-arrow {
    rotate: 180deg;
}
.tab-menu {
    position: absolute;
    min-width: 200px;
    top: 100%;
    left: 12px;
    background-color: white;
    border: 1px solid #e9e9e9;
    box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.05);
    z-index: 1;
    transform: scale(0);
    transition: all 0.2s;
}
.tab-menu::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: white;
    border-top: 1px solid #e9e9e9;
    border-left: 1px solid #e9e9e9;
    rotate: 45deg;
    top: -10px;
    left: 75px;
    z-index: -1;
}
.tab-menu .tab-box-video {
    padding: 0;
}
.tab-menu .tab-box-video ul {
    flex-direction: column;
    padding-left: 0;
    align-items: flex-start;
}
.tab-menu .tab-box-video ul li {
    font-size: 15px;
    margin: 0;
    border-top: none;
    padding: 6px 12px;
    width: 100%;
    white-space: nowrap;
    cursor: pointer;
}
.tab-menu .tab-box-video ul li:hover {
    color: #5e35b1
}
.tab-menu .tab-box-video ul li.active {
    background-color: #f1eafe;
}

/* #preview-Modal {
    padding: 0 !important;
}
#preview-Modal .modal-dialog {
    margin: 0;
    max-width: 100%;
}
#preview-Modal .modal-dialog .video-js.vjs-16-9 {
    padding-top: calc(100vh - 170px);
} */

.btn-bulk {
    background-color: white;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 12px;
    border-color: #6c2fbb !important;
}
.btn-bulk.btn-delete {
    padding-block: 9px;
    background-color: #dd3939;
    border-color : #dd3939 !important;
}
.btn-bulk.bulk-active-button{
    background-color: #6c2fbb;
}
.btn-bulk.bulk-active-button img{
    filter: brightness(0) invert(1)
}
.bulk-active {
    border: 1px solid #6c2fbb;
    border-radius: 16px;
    box-shadow: 0 0 6px 2px rgba(108, 47, 187, 0.15);
    position: relative;
}
.bulk-active .bulk-check {
    display: flex;
    align-items: center;
    justify-content: center;
}
.bulk-active .bulk-check i {
    font-size: 22px;
    color: #6c2fbb;
    background: white;
    border-radius: 100%;
}
.question-mark {
    position: absolute;
    top: 10px;
    right: 10px;
}

@media (max-width: 1500px) {
    .img-box {
        height: 172px;
    }
}


@media (max-width: 1400px) {

    .tab-box-video ul li {
        font-size: 18px;
        white-space: nowrap;
    }
    /* #preview-Modal .modal-dialog .video-js .vjs-tech {
        left: 50%;
        transform: translateX(-50%);
        width: fit-content;
    } */

}


@media (max-width: 1200px) {
    .tab-box-video ul {
        /* overflow-x: auto; */
        padding-bottom: 10px;

    }

    .tab-box-video ul::-webkit-scrollbar {
        height: 7px;
    }
    ::ng-deep .questionnaries-section {
        max-width: 95% !important;
    }
}

@media (max-width: 992px) {
    #preview-Modal .modal-dialog .video-js .vjs-tech {
        height: 100% !important;
    }
}
@media (max-width: 991px) {
    .library-select {
        margin-left: auto;
    }
    .folderSort {
        flex-wrap: wrap;
        row-gap: 10px;
    }
}


@media (max-width: 850px) {
    ::ng-deep .recored-section {
        max-width: 95% !important;
    }
}
@media (max-width: 768px) {
    .tab-box-video ul {
        justify-content: start;
    }

    .group-box {
        margin-top: 10px;
        padding: 10px 10px;
    }

    .tab-box-video ul li {
        font-size: 17px;
    }

    .add-box h5 {
        font-size: 18px;
    }
}

@media (max-width: 575px) {
    .img-box {
        height: 200px;
    }
    #modalForDisplayVideoList img, #modalForMoveVideoListToFolder img {
        height: 70px;
        width: 70px !important;
    }
    .custom-card .v-title {
        white-space: break-spaces;
        margin-right: 15px;
    }
    .custom-card {
        padding-top: 0;
    }
    .pointer .form-check-label {
        gap: 0 !important;
    }
    .vid-options > label {
        top: 0;
    }
} 

.select-vid-area {
    border: 1px dotted black;
    border-radius: 10px;
    padding: 28px 15px;
    margin: 15px;
}


.detele-btn-doc{
    width: 30px;
    height: 30px;
    background-color:#808080;
    display:flex;
    justify-content: center;
    align-items: center;
}

.detele-btn-doc img{
    width: 20px;
    height:20px;
}

.detele-btn-doc{
    width: 25px;
    height: 25px;
    background-color: #808080;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.doc-group {
    position: absolute;
    top: 0;
    right: 25px;
    display: flex;
    align-items: center;
    gap: 10px;
}

#foldersModal p{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 15px;
}

::ng-deep .recored-section{
    overflow: auto;
}

::ng-deep .form-group .vjs-poster{
    background-color: black;
}
::ng-deep .vjs-poster{
    background-color: white;
}

.verticalVideo div{
    width: 400px;
    height: 600px;
    object-fit: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    margin:auto;
    border-radius: 10px;
}

.verticalVideo video{
    width:100%;
    height:100%;
    object-fit:none;
}


::ng-deep .verticalVideo .vjs-poster {
    background-repeat: no-repeat !important;
    background-position: 100% 100% !important;
    background-size: cover !important;
    width:100 !important;
}

::ng-deep .svg-wrapper svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.updateTranscript i {
    color: white;
    font-size: 17px;
    margin-top: 6px;
}

.dots-delete {
    position: absolute;
    top: 12px;
    right: 12px;
    background-color: #929292a2;
    display: flex;
    cursor: pointer;
    align-items: center;
    -moz-column-gap: 10px;
    column-gap: 10px;
    padding: 7px 8px;
    border-radius: 5px;
}

.dots-dropdown .dropdown-item:active,
.dots-dropdown .dropdown-item:hover {
    background-color: #d3d2d2;
    color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/library/library.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;;AAGA;IACI,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,SAAS;IACT,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI;gCAC4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;;AAGA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB,2BAA2B;AAC3B,+BAA+B;AAC/B,oBAAoB;;AAEpB,IAAI;;AAEJ;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,oBAAe;SAAf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;;IAEnB;oBACgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,wCAA+D;IAC/D,4BAA4B;IAC5B,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,MAAM;AACV;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,yBAAyB;IACzB,2CAA2C;IAC3C,UAAU;IACV,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,UAAU;IACV,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI;AACJ;AACA;IACI,yBAAyB;AAC7B;;AAEA;;;;;;;;;GASG;;AAEH;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iCAAiC;AACrC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI;AACJ;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;;AAGA;;IAEI;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;;;;OAIG;;AAEP;;;AAGA;IACI;QACI,sBAAsB;QACtB,oBAAoB;;IAExB;;IAEA;QACI,WAAW;IACf;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,aAAa;IACjB;AACJ;;;AAGA;IACI;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,YAAY;QACZ,sBAAsB;IAC1B;IACA;QACI,yBAAyB;QACzB,kBAAkB;IACtB;IACA;QACI,cAAc;IAClB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,MAAM;IACV;AACJ;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;;AAGA;IACI,uCAAuC;IACvC,yCAAyC;IACzC,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,yBAAyB;IACzB,WAAW;AACf","sourcesContent":[".library {\r\n    margin-top: 25px;\r\n}\r\n\r\n\r\n.tab-box-video {\r\n    width: 100%;\r\n\r\n}\r\n\r\n.tab-box-video ul {\r\n    display: flex;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.tab-box-video ul li {\r\n    list-style: none;\r\n    /* font-weight: 500; */\r\n    font-size: 18px;\r\n    padding: 5px 0;\r\n    margin: 0px 25px;\r\n    color: #878395;\r\n    cursor: pointer;\r\n}\r\n\r\n.tab-box-video ul li svg {\r\n    fill: #878395;\r\n}\r\n\r\n.tab-box-video ul li.active {\r\n    border-top: 3px solid #6c2fbb;\r\n    color: #6c2fbb;\r\n}\r\n\r\n.tab-box-video ul li.active svg {\r\n    fill: rgba(108, 47, 187, 1);\r\n}\r\n\r\n.like-cmt-select > select {\r\n    height: 50px;\r\n    font-size: 15px;\r\n}\r\n\r\n.like-cmt-select > span {\r\n    position: absolute;\r\n    font-size: 13px;\r\n    left: 30px;\r\n    top: 2px;\r\n    color: #878787;\r\n}\r\n\r\n.like-cmt-select button span {\r\n    border-left: 5px solid transparent;\r\n    border-right: 5px solid transparent;\r\n    border-top: 6px solid #555;\r\n    display: inline-block;\r\n}\r\n\r\n.like-cmt-select button {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    right: 16px;\r\n    top: 25px;\r\n    width: 50px;\r\n    background-color: #f5f7f6;\r\n}\r\n\r\n.like-cmt-select button.sort-videos {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    /* left: 117px; */\r\n    top: 25px;\r\n    padding: 0;\r\n    width: 26px;\r\n    background-color: #f5f7f6;\r\n}\r\n\r\n.poster {\r\n    width: 100%;\r\n    height: 160px;\r\n}\r\n\r\n.custom-card {\r\n    /* background-color: #fff; */\r\n    width: 100%;\r\n    height: auto;\r\n    padding: 6px;\r\n    /* box-shadow: 0px 0px 10px 0px #dad8d8; */\r\n}\r\n\r\n.custom-card .v-title-edit {\r\n    display: flex;\r\n}\r\n\r\n.custom-card .v-title-edit .v-title-btn {\r\n    cursor: pointer;\r\n    margin: 0;\r\n    display: none;\r\n    padding-left: 5px;\r\n}\r\n\r\n.custom-card .v-title-edit:hover .v-title-btn {\r\n    display: inline-block;\r\n}\r\n.v-title-edit:hover .v-title-btn {\r\n    display: inline-block;\r\n}\r\n\r\n.custom-card .v-title {\r\n    padding: 2px;\r\n    cursor: text;\r\n    font-weight: 500;\r\n    font-size: 14px;\r\n    color: #000;\r\n}\r\n\r\n.custom-card p {\r\n\r\n    /*font-size: 16px;\r\n    font-weight:400 !important;*/\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    width: inherit;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n    color: rgba(136, 133, 142, 1);\r\n}\r\n\r\n.move-check {\r\n    width: 20px;\r\n    height: 20px;\r\n    border-color: #bdbdbd;\r\n    box-shadow: none;\r\n}\r\n.move-check:checked {\r\n    background-color: #6c2fbb;\r\n    border-color: #6c2fbb;\r\n}\r\n\r\n\r\n.btn-delete {\r\n    background-color: #6c2fbb;\r\n    color: #FFF;\r\n    border-radius: 4px;\r\n}\r\n\r\n.btn-login {\r\n    color: #6c2fbb;\r\n    border: 1px solid #6c2fbb;\r\n    border-radius: 4px;\r\n}\r\n\r\n.FF-scroll-modify {\r\n    /*max-height: 720px;*/\r\n    /*height: 100%;*/\r\n    height: 66vh;\r\n    overflow-x: hidden;\r\n    overflow-y: scroll;\r\n    margin-top: 20px;\r\n}\r\n\r\n/*.vid-options select {*/\r\n/*    border-radius: 10px;*/\r\n/*    border: none !important;*/\r\n/*    height: 50px;*/\r\n\r\n/*}*/\r\n\r\n.vid-options {\r\n    width: 100%;\r\n}\r\n\r\n.vid-options > select {\r\n    height: 50px;\r\n    font-size: 15px;\r\n}\r\n.vid-options > label {\r\n    position: absolute;\r\n    font-size: 15px;\r\n    left: 30px;\r\n    top: 15px;\r\n    color: #878787;\r\n}\r\n\r\n.group-box {\r\n    padding: 30px;\r\n    border-radius: 16px;\r\n    background-color: #ffff;\r\n}\r\n\r\n.dots {\r\n    background-color: #000000a2;\r\n    display: flex;\r\n    align-items: center;\r\n    column-gap: 5px;\r\n    border-radius: 0 5px;\r\n}\r\n\r\n.dots-dropdown {\r\n    position: absolute;\r\n    top: 12px;\r\n    right: 12px;\r\n    background-color: #929292a2;\r\n    display: flex;\r\n    cursor: pointer;\r\n    align-items: center;\r\n    -moz-column-gap: 10px;\r\n    column-gap: 10px;\r\n    padding: 7px 12px;\r\n    border-radius: 5px;\r\n}\r\n.dots-dropdown .dropdown-menu {\r\n    padding-block: 4px;\r\n    min-width: 120px;\r\n}\r\n.dots-dropdown .dropdown-item {\r\n    padding: 7px 15px;\r\n}\r\n.dots-dropdown .dropdown-item:active,\r\n.dots-dropdown .dropdown-item:hover {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\n.bulk-group {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.dots-btn {\r\n    cursor: pointer;\r\n    padding: 7px 10px;\r\n}\r\n\r\n.badge-box-container {\r\n    text-align: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.img-box {\r\n    /*cursor: pointer;*/\r\n    aspect-ratio: 16/9;\r\n    display: flex;\r\n    justify-content: center;\r\n    /*height: 200px;*/\r\n    width: 100%;\r\n    border-radius: 16px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    background: #f8f9fa;\r\n    align-items: center;\r\n\r\n    /* cursor: pointer;\r\n    height: 200px; */\r\n}\r\n\r\n.group-box .add-box {\r\n    aspect-ratio: 16/9;\r\n    position: relative;\r\n    width: 100%;\r\n    /* min-height: 200px; */\r\n    height: 100%;\r\n    border: 2px solid #6c2fbb;;\r\n    border-radius: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.group-box .add-box .plus {\r\n    width: 28px;\r\n    height: 26px;\r\n    background: #F8FAFB;\r\n    border-radius: 4px;\r\n    text-align: center;\r\n}\r\n\r\n.group-box .add-box h5 {\r\n    color: #6c2fbb;\r\n}\r\n\r\n.img-box img {\r\n    object-fit: fill;\r\n}\r\n\r\n.showPdf img {\r\n    width: 190px;\r\n    height: 175px;\r\n    /*min-width: 168px; */\r\n}\r\n.showPdf input{\r\n    text-align: center;\r\n    padding: 2px 0 2px 5px;\r\n    cursor: text;\r\n    font-weight: 500;\r\n    font-size: 15px;\r\n    color: #000;\r\n}\r\n.docBox{\r\n    max-height: 220px;\r\n}\r\n\r\n.folderSort{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.information-modal p{\r\n    color: gray;\r\n    font-size: 18px;\r\n}\r\n\r\n.information-modal button{\r\n    color: white;\r\n    padding: 10px 26px;\r\n    font-size: 18px;\r\n    border: none;\r\n    background: #6c2fbb;\r\n    border-radius: 6px;\r\n}\r\n\r\n.pdf-edit{\r\n    display: none;\r\n}\r\n\r\n.pdf-title:hover .pdf-edit{\r\n    display: block;\r\n}\r\n\r\n.folder-section{\r\n    padding: 6px;\r\n}\r\n\r\n.folder-section p{\r\n    padding: 2px;\r\n    cursor: text;\r\n    font-weight: 500;\r\n    font-size: 14px;\r\n    color: #000;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.folder-table{\r\n    height: 66vh;\r\n    overflow-x: hidden;\r\n    overflow-y: scroll;\r\n}\r\n\r\n.folder-table table tbody tr{\r\n    line-height: 3;\r\n}\r\n\r\nol li{\r\n    font-size: 18px;\r\n}\r\n\r\n.breadcrumb-item.active{\r\n    color: #6c2fbb !important;\r\n    font-weight: bold;\r\n    margin: -2px 0 0 0;\r\n}\r\n\r\n.firstLi{\r\n    cursor: pointer;\r\n}\r\n\r\n.addFolderButton button{\r\n    font-size: 15px;\r\n    border: 2px solid #6c2fbb;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 7px;\r\n    color: #6c2fbb;\r\n    font-weight: 500;\r\n    border-radius: 8px;\r\n}\r\n.folderModalBody{\r\n    display: flex;\r\n    flex-direction: column;\r\n    text-align: start;\r\n    margin-top: 30px;\r\n    padding: 0 16px;\r\n}\r\n\r\n.folderModalBody input{\r\n    height: 45px;\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n}\r\n\r\n.folderModalBody label{\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n}\r\n\r\n#modalForAddFolder h4{\r\n    border-bottom: 1px solid #e1e1e1;\r\n    line-height: 2.5;\r\n}\r\n\r\n#modalForAddFolder .btnSave, #modalForDisplayVideoList .btnSave, #modalForMoveVideoListToFolder .btnSave, #foldersModal .btnSave{\r\n    font-size: 15px;\r\n    border: 2px solid #6c2fbb;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 7px;\r\n    color: white;\r\n    font-weight: 500;\r\n    border-radius: 5px;\r\n    background: #6c2fbb\r\n}\r\n\r\n.mainsection{\r\n    height: calc(100vh - 120px);\r\n    overflow: auto;\r\n}\r\n\r\n#modalForDisplayVideoList img, #modalForMoveVideoListToFolder img{\r\n    height: 70px;\r\n    width: 180px !important;\r\n}\r\n\r\n#modalForDisplayVideoList .form-check-input, #modalForMoveVideoListToFolder .form-check-input{\r\n    position: unset !important;\r\n}\r\n\r\n.videoImage{\r\n    object-fit: fill;\r\n    height: 100%;\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item::before {\r\n    display: inline-block;\r\n    padding-right: .5rem;\r\n    color: #6c757d;\r\n    content: \">\";\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item::before {\r\n    display: inline-block;\r\n    padding-right: .5rem;\r\n    color: #6c757d;\r\n    content: \"\";\r\n    background-image: url('../../../assets/images/right-arrow.svg');\r\n    background-repeat: no-repeat;\r\n    background-size: contain;\r\n    width: 20px;\r\n    height: 15px;\r\n    margin-top: 8px;\r\n}\r\n\r\n.badgeAction {\r\n    text-align: end;\r\n    position: absolute;\r\n    right: 15px;\r\n    top: 0;\r\n}\r\n\r\n\r\n.badge-box .badge-rounded{\r\n    z-index: 0 !important;\r\n}\r\n\r\n.popup-objective {\r\n    z-index: 1;\r\n    position: absolute;\r\n    background: white;\r\n    padding: 0 7px;\r\n    border-radius: 6px;\r\n    width: fit-content;\r\n    top: 30px;\r\n    width: 200px;\r\n    height: 210px;\r\n    overflow: auto;\r\n    left: -66px\r\n}\r\n\r\n.popup-objective ul {\r\n    text-align: start;\r\n    padding-left: 25px;\r\n}\r\n\r\n.popup-objective li {\r\n    margin-top: 10px;\r\n}\r\n\r\n.verticalLine{\r\n    border-left: 1px solid #9b9b9b;\r\n    height: 16px;\r\n    display: block;\r\n}\r\n\r\n.tab-dropdown {\r\n    position: relative;\r\n}\r\n.tab-dropdown:hover .tab-menu {\r\n    transform: scale(1);\r\n}\r\n.tab-dropdown .tab-arrow {\r\n    transition: all 0.2s;\r\n}\r\n.tab-dropdown:hover .tab-arrow {\r\n    rotate: 180deg;\r\n}\r\n.tab-menu {\r\n    position: absolute;\r\n    min-width: 200px;\r\n    top: 100%;\r\n    left: 12px;\r\n    background-color: white;\r\n    border: 1px solid #e9e9e9;\r\n    box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.05);\r\n    z-index: 1;\r\n    transform: scale(0);\r\n    transition: all 0.2s;\r\n}\r\n.tab-menu::after {\r\n    content: '';\r\n    position: absolute;\r\n    width: 20px;\r\n    height: 20px;\r\n    background-color: white;\r\n    border-top: 1px solid #e9e9e9;\r\n    border-left: 1px solid #e9e9e9;\r\n    rotate: 45deg;\r\n    top: -10px;\r\n    left: 75px;\r\n    z-index: -1;\r\n}\r\n.tab-menu .tab-box-video {\r\n    padding: 0;\r\n}\r\n.tab-menu .tab-box-video ul {\r\n    flex-direction: column;\r\n    padding-left: 0;\r\n    align-items: flex-start;\r\n}\r\n.tab-menu .tab-box-video ul li {\r\n    font-size: 15px;\r\n    margin: 0;\r\n    border-top: none;\r\n    padding: 6px 12px;\r\n    width: 100%;\r\n    white-space: nowrap;\r\n    cursor: pointer;\r\n}\r\n.tab-menu .tab-box-video ul li:hover {\r\n    color: #5e35b1\r\n}\r\n.tab-menu .tab-box-video ul li.active {\r\n    background-color: #f1eafe;\r\n}\r\n\r\n/* #preview-Modal {\r\n    padding: 0 !important;\r\n}\r\n#preview-Modal .modal-dialog {\r\n    margin: 0;\r\n    max-width: 100%;\r\n}\r\n#preview-Modal .modal-dialog .video-js.vjs-16-9 {\r\n    padding-top: calc(100vh - 170px);\r\n} */\r\n\r\n.btn-bulk {\r\n    background-color: white;\r\n    border-radius: 8px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 10px 12px;\r\n    border-color: #6c2fbb !important;\r\n}\r\n.btn-bulk.btn-delete {\r\n    padding-block: 9px;\r\n    background-color: #dd3939;\r\n    border-color : #dd3939 !important;\r\n}\r\n.btn-bulk.bulk-active-button{\r\n    background-color: #6c2fbb;\r\n}\r\n.btn-bulk.bulk-active-button img{\r\n    filter: brightness(0) invert(1)\r\n}\r\n.bulk-active {\r\n    border: 1px solid #6c2fbb;\r\n    border-radius: 16px;\r\n    box-shadow: 0 0 6px 2px rgba(108, 47, 187, 0.15);\r\n    position: relative;\r\n}\r\n.bulk-active .bulk-check {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.bulk-active .bulk-check i {\r\n    font-size: 22px;\r\n    color: #6c2fbb;\r\n    background: white;\r\n    border-radius: 100%;\r\n}\r\n.question-mark {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n}\r\n\r\n@media (max-width: 1500px) {\r\n    .img-box {\r\n        height: 172px;\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 1400px) {\r\n\r\n    .tab-box-video ul li {\r\n        font-size: 18px;\r\n        white-space: nowrap;\r\n    }\r\n    /* #preview-Modal .modal-dialog .video-js .vjs-tech {\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n        width: fit-content;\r\n    } */\r\n\r\n}\r\n\r\n\r\n@media (max-width: 1200px) {\r\n    .tab-box-video ul {\r\n        /* overflow-x: auto; */\r\n        padding-bottom: 10px;\r\n\r\n    }\r\n\r\n    .tab-box-video ul::-webkit-scrollbar {\r\n        height: 7px;\r\n    }\r\n    ::ng-deep .questionnaries-section {\r\n        max-width: 95% !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    #preview-Modal .modal-dialog .video-js .vjs-tech {\r\n        height: 100% !important;\r\n    }\r\n}\r\n@media (max-width: 991px) {\r\n    .library-select {\r\n        margin-left: auto;\r\n    }\r\n    .folderSort {\r\n        flex-wrap: wrap;\r\n        row-gap: 10px;\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 850px) {\r\n    ::ng-deep .recored-section {\r\n        max-width: 95% !important;\r\n    }\r\n}\r\n@media (max-width: 768px) {\r\n    .tab-box-video ul {\r\n        justify-content: start;\r\n    }\r\n\r\n    .group-box {\r\n        margin-top: 10px;\r\n        padding: 10px 10px;\r\n    }\r\n\r\n    .tab-box-video ul li {\r\n        font-size: 17px;\r\n    }\r\n\r\n    .add-box h5 {\r\n        font-size: 18px;\r\n    }\r\n}\r\n\r\n@media (max-width: 575px) {\r\n    .img-box {\r\n        height: 200px;\r\n    }\r\n    #modalForDisplayVideoList img, #modalForMoveVideoListToFolder img {\r\n        height: 70px;\r\n        width: 70px !important;\r\n    }\r\n    .custom-card .v-title {\r\n        white-space: break-spaces;\r\n        margin-right: 15px;\r\n    }\r\n    .custom-card {\r\n        padding-top: 0;\r\n    }\r\n    .pointer .form-check-label {\r\n        gap: 0 !important;\r\n    }\r\n    .vid-options > label {\r\n        top: 0;\r\n    }\r\n} \r\n\r\n.select-vid-area {\r\n    border: 1px dotted black;\r\n    border-radius: 10px;\r\n    padding: 28px 15px;\r\n    margin: 15px;\r\n}\r\n\r\n\r\n.detele-btn-doc{\r\n    width: 30px;\r\n    height: 30px;\r\n    background-color:#808080;\r\n    display:flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.detele-btn-doc img{\r\n    width: 20px;\r\n    height:20px;\r\n}\r\n\r\n.detele-btn-doc{\r\n    width: 25px;\r\n    height: 25px;\r\n    background-color: #808080;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.doc-group {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 25px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n#foldersModal p{\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    font-size: 15px;\r\n}\r\n\r\n::ng-deep .recored-section{\r\n    overflow: auto;\r\n}\r\n\r\n::ng-deep .form-group .vjs-poster{\r\n    background-color: black;\r\n}\r\n::ng-deep .vjs-poster{\r\n    background-color: white;\r\n}\r\n\r\n.verticalVideo div{\r\n    width: 400px;\r\n    height: 600px;\r\n    object-fit: cover;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin:auto;\r\n    border-radius: 10px;\r\n}\r\n\r\n.verticalVideo video{\r\n    width:100%;\r\n    height:100%;\r\n    object-fit:none;\r\n}\r\n\r\n\r\n::ng-deep .verticalVideo .vjs-poster {\r\n    background-repeat: no-repeat !important;\r\n    background-position: 100% 100% !important;\r\n    background-size: cover !important;\r\n    width:100 !important;\r\n}\r\n\r\n::ng-deep .svg-wrapper svg {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: contain;\r\n}\r\n\r\n.updateTranscript i {\r\n    color: white;\r\n    font-size: 17px;\r\n    margin-top: 6px;\r\n}\r\n\r\n.dots-delete {\r\n    position: absolute;\r\n    top: 12px;\r\n    right: 12px;\r\n    background-color: #929292a2;\r\n    display: flex;\r\n    cursor: pointer;\r\n    align-items: center;\r\n    -moz-column-gap: 10px;\r\n    column-gap: 10px;\r\n    padding: 7px 8px;\r\n    border-radius: 5px;\r\n}\r\n\r\n.dots-dropdown .dropdown-item:active,\r\n.dots-dropdown .dropdown-item:hover {\r\n    background-color: #d3d2d2;\r\n    color: #000;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
